// Session Manager - handles session expiration events across the app

type SessionEventCallback = () => void;

class SessionManager {
  private listeners: Set<SessionEventCallback> = new Set();
  private isSessionExpired: boolean = false;

  // Subscribe to session expiration events
  subscribe(callback: SessionEventCallback): () => void {
    this.listeners.add(callback);
    // Return unsubscribe function
    return () => {
      this.listeners.delete(callback);
    };
  }

  // Trigger session expiration - shows modal to user
  triggerSessionExpired(): void {
    if (this.isSessionExpired) return; // Prevent multiple triggers
    this.isSessionExpired = true;
    this.listeners.forEach(callback => callback());
  }

  // Reset session state (after user logs in again)
  resetSession(): void {
    this.isSessionExpired = false;
  }

  // Check if session is currently expired
  getIsSessionExpired(): boolean {
    return this.isSessionExpired;
  }
}

// Singleton instance
export const sessionManager = new SessionManager();
